export default __webpack_public_path__ + "static/media/greenM.21645764.svg";